import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { TwoColumnListContentLayoutComponent } from './two-column-list-layout.component';

@NgModule({
   declarations: [TwoColumnListContentLayoutComponent],
   exports: [TwoColumnListContentLayoutComponent],
   imports: [CommonModule, RouterModule, MatSidenavModule],
})
export class TwoColumnListContentLayoutModule {}
